import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ApplicationLogo } from "@advosys/component-advosys-react";
import { ApplicationLayout, Box, createToolbarItemLink, createToolbarItemSection } from "@advosys/component-react";
import { hasValue } from "@advosys/component-react-utils";
import { usePages } from "src/use-pages";
import { authenticationActions } from "src/domains/authentication";
import { useT } from "./main-layout-i18n";
import { ErrorHandler } from "./components/error-handler";
import { AboutDialog } from "./components/about-dialog/about-dialog";
import { EasterEgg } from "./components/easter-egg/easter-egg";
import { SettingsDialog } from "./components/settings-dialog/settings-dialog";
const baseTitle = "Unik Advosys";
const mapStateToProps = (state) => ({
    userName: state.authentication.authentication.account?.username
});
const MainLayoutBase = (props) => {
    const { tenantId } = useParams();
    const navigate = useNavigate();
    const { t } = useT();
    const { children, title, logoutRequest, toolbarItems = [], helpToolbarItems = [], ...rest } = props;
    const [settingsDialogVisible, setSettingsDialogVisible] = useState(false);
    const [aboutDialogVisible, setAboutDialogVisible] = useState(false);
    useEffect(() => {
        if (hasValue(title)) {
            document.title = `${baseTitle} - ${title}`;
        }
        else {
            document.title = baseTitle;
        }
    }, [title]);
    useEffect(() => {
        return () => {
            document.title = baseTitle;
        };
    }, []);
    const makeAbsoluteUrl = (url) => `/${tenantId}/${url}`;
    const pages = usePages();
    const navigationItems = useMemo(() => pages.map(pg => ({
        key: pg.key,
        name: pg.name,
        icon: pg.icon,
        subItems: pg.pages.map(p => ({ key: p.key, name: p.name, url: makeAbsoluteUrl(p.url) }))
    })), [tenantId, pages]);
    const toolbarItemsWithGlobalItems = useMemo(() => [
        ...toolbarItems,
        {
            icon: "Help",
            items: [...helpToolbarItems, createToolbarItemSection(t.support, [createToolbarItemLink(t.about, undefined, () => setAboutDialogVisible(true), false, true)])]
        },
        {
            icon: "Contact",
            items: [
                createToolbarItemSection(props.userName ?? "", [
                    createToolbarItemLink(t.settings, "Settings", () => setSettingsDialogVisible(true), false, true),
                    createToolbarItemLink(t.signOut, "SignOut", logoutRequest, false, true)
                ])
            ]
        }
    ], [toolbarItems, helpToolbarItems, t]);
    const handleNavigation = useCallback((item) => hasValue(item.url) && navigate(item.url), [navigate]);
    return (_jsxs(_Fragment, { children: [_jsx(ApplicationLayout, { logo: _jsx(Box, { paddingTop: theme => theme.spacing.s2, children: _jsx(ApplicationLogo, { color: "white" }) }), ...rest, title: title, navigationItems: navigationItems, navigationOnItemSelect: handleNavigation, toolbarItems: toolbarItemsWithGlobalItems, children: children }), _jsx(ErrorHandler, {}), settingsDialogVisible && _jsx(SettingsDialog, { onOk: () => setSettingsDialogVisible(false), onCancel: () => setSettingsDialogVisible(false) }), aboutDialogVisible && _jsx(AboutDialog, { onDismiss: () => setAboutDialogVisible(false) }), _jsx(EasterEgg, {})] }));
};
export const MainLayout = connect(mapStateToProps, authenticationActions)(MainLayoutBase);
